import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
var r = {
	12: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 1.125C8.69239 1.125 10.875 3.30761 10.875 6C10.875 8.69239 8.69239 10.875 6 10.875C3.30761 10.875 1.125 8.69239 1.125 6C1.125 3.30761 3.30761 1.125 6 1.125ZM3.90015 5.36279C3.54806 5.36279 3.26294 5.64792 3.26294 6C3.26294 6.35208 3.54806 6.63721 3.90015 6.63721H8.09985C8.45187 6.63713 8.73779 6.35203 8.73779 6C8.73779 5.64797 8.45187 5.36287 8.09985 5.36279H3.90015Z",
				fill: "#8F8B85"
			})
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5ZM5.2002 7.15039C4.73075 7.15039 4.35059 7.53056 4.35059 8C4.35059 8.46944 4.73075 8.84961 5.2002 8.84961H10.7998C11.2692 8.8495 11.6504 8.46938 11.6504 8C11.6504 7.53062 11.2692 7.1505 10.7998 7.15039H5.2002Z",
				fill: "#8F8B85"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 5.51269 5.51269 1.875 10 1.875ZM6.50024 8.93799C5.91344 8.93799 5.43823 9.4132 5.43823 10C5.43823 10.5868 5.91344 11.062 6.50024 11.062H13.4998C14.0864 11.0619 14.563 10.5867 14.563 10C14.563 9.41328 14.0864 8.93812 13.4998 8.93799H6.50024Z",
				fill: "#8F8B85"
			})
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM7.80029 10.7256C7.09613 10.7256 6.52588 11.2958 6.52588 12C6.52588 12.7042 7.09613 13.2744 7.80029 13.2744H16.1997C16.9037 13.2743 17.4756 12.7041 17.4756 12C17.4756 11.2959 16.9037 10.7257 16.1997 10.7256H7.80029Z",
				fill: "#8F8B85"
			})
		}),
		width: 24,
		height: 24
	}
}, i = ({ size: t = 16, ...i }) => /* @__PURE__ */ n(e, {
	source: r[t],
	...i
});
//#endregion
export { i as StatusBlockingIcon };
